import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { Link } from 'react-router';
import { filter } from 'lodash/collection';
import ProgramCard from './ProgramCard';
import FestivalOrgs from './FestivalOrgs';
import { isEmpty } from 'lodash/lang';


class ProgramCategory extends Component {
  constructor(props) {
    super(props);
  }

  createContentMarkup = (content) => {
    return { __html: content };
  };



  render() {

    if (!this.props.programCategories.isLoaded) {
      return  <span />;
    }

    if (!this.props.girlsFestivalProgramEventsByCategory.isLoaded && this.props.page != 'default') {
      return  <span />;
    }

    if (!this.props.orgsByType.isLoaded) {
      return  <span />;
    }


    let programCategories = this.props.programCategories;
    let orgsByType = this.props.orgsByType.results;
    let girlsFestivalProgramEventsByCategory = this.props.girlsFestivalProgramEventsByCategory;
    let eventList;
    let programLP = this.props.programLP;
    let page = this.props.page;
    let categoryId = this.props.page;
    let currentProgramCard;

    // The exhibitor list are the org thumbnails that are participating as
    // exhibitors
    let showExhibitorList = false;

    currentProgramCard = filter(programCategories, function(obj) {
      return obj.id == page
    })

    if (!isEmpty(currentProgramCard)) {
      if (currentProgramCard[0].is_exhibitor_list) {
        showExhibitorList = true;
      }
    }

    let programPageHeadline = '';
    let programPageCopy = '';
    let programPageDefaultHeadline = '';
    let programPageDefaultCopy = '';



    programPageDefaultHeadline = programLP[0].headline;

    programPageDefaultCopy = <div className="festivalProgram-lpWrapper" dangerouslySetInnerHTML={this.createContentMarkup(programLP[0].intro_copy)}></div>;


    // Get Program Category header and intro copy
    if (this.props.page == 'default') { // If on program lp and not program category page

      programPageHeadline = programPageDefaultHeadline;
      programPageCopy = programPageDefaultCopy;

    } else { // Not on default page now

      programPageHeadline = currentProgramCard[0].event_title;
      programPageCopy = <div dangerouslySetInnerHTML={this.createContentMarkup(currentProgramCard[0].event_intro_copy)}></div>;
    }


    // This section of code deals with what should be displayed after the
    // header and intro copy
    if (page != 'default' && !showExhibitorList) {
      // Get each program card for this program category
      eventList = girlsFestivalProgramEventsByCategory.map((event, index) => {
        return <ProgramCard
          key={event.id}
          id={event.id}
          title={event.title}
          bodyCopy={event.body_copy}
          bannerUrl={event.banner_image}
          room={event.room_name}
          times={event.times}
          isAllDay={event.is_all_day}
          page={this.props.page}
        />
      });
    } else if (showExhibitorList) {
        eventList = <FestivalOrgs
                orgsByType = {this.props.orgsByType}
                user = {this.props.auth.user}
                loadOrgsByType = {this.props.loadOrgsByType}
                />
    } else {
      // this is the default or program landing page with only
      eventList = '';
    }




    return(
      <div>
        <div>
          <div className="festivalProgramHeaderTagWrapper headerTagWrapper">
            <h1 className="page-heading">{programPageHeadline}</h1>

            {programPageCopy}
          </div>
        </div>

        <div>
          {eventList}
        </div>
      </div>



    );
  }
}

function mapStateToProps(state) {
  return state;
};

export default connect(
  mapStateToProps,
  {
    Link,
    push
  }

)(ProgramCategory);



// WEBPACK FOOTER //
// ./src/components/festival/program/ProgramCategory.jsx